import { MAIN_APP } from "../app/routes";

/** Prefiks aplikacji z aktualnego adresu: `/shop` albo `/eAktywniReactApp`. */
export function resolveAppBase(pathname: string): string {
  const publicBase = (MAIN_APP || "").replace(/\/$/, "");
  const normalized = pathname.replace(/\/$/, "") || "/";
  if (publicBase && (normalized === publicBase || normalized.startsWith(`${publicBase}/`))) {
    return publicBase;
  }

  const [firstSegment] = normalized.split("/").filter(Boolean);
  return firstSegment ? `/${firstSegment}` : publicBase;
}

/** Dokleja prefiks aplikacji do ścieżki względnej, np. `/customOffer?offerId=…`. */
export function prefixWithAppBase(relativePath: string, pathname: string): string {
  const base = resolveAppBase(pathname);
  const path = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
  if (!base || path === base || path.startsWith(`${base}/`) || path.startsWith(`${base}?`)) {
    return path;
  }
  return `${base}${path}`;
}
